import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import Tooltip from '../tooltip/tooltip.component';
import FormatService from '../../services/format-service';
import useStylesStatusIconBlock from './status-icon-block.styles';

const StatusIconBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    withLeftOffset,
    withRightOffset,
    title,
    className,
    children,
  } = props;

  const { classes } = useStylesStatusIconBlock();

  const offsetClassName: string | undefined = withLeftOffset ? classes.statusIconBlockLeftOffset : undefined;
  const rightOffsetClassName: string | undefined = withRightOffset ? classes.statusIconBlockRightOffset : undefined;

  return (
    <FlexContainer
      className={FormatService.formatClassNames(
        classes.statusIconBlock, offsetClassName, rightOffsetClassName, className,
      )}
    >
      {
        !!children && (
          <Tooltip title={title}>
            {children}
          </Tooltip>
        )
      }
    </FlexContainer>
  );
});

export default StatusIconBlock;
